import React from 'react'

import { ZariContext } from '_zari/context'

import { Portlet, Form, Col, Row, Button } from '_zari/core'

import { CodigosTransaccionesConstant } from 'constants/index'

import * as FormGroups from './formGroups'

import * as AsientoContableService from 'services/asientosContables.service'

const portletBreadcrumbs = [
  { name: 'Asientos Contables', path: `/${CodigosTransaccionesConstant.ASIENTOSCONTABLES_NODOMICILIADOS}` },
  { name: 'No Domiciliados' }
]

const FiltrosSection = ({ limpiarIdDocumento, asignarIdDocumento }) => {
  const __zariContext = React.useContext(ZariContext)

  const [razonSocialSocio, setRazonSocialSocio] = React.useState(null)
  const [idAsientoContable, setIdAsientoContable] = React.useState(null)
  const [listaAsientosContables, setListaAsientosContables] = React.useState([])

  const asignarDatos = React.useCallback(
    ({ _idSocio, razonSocial }) => {
      setRazonSocialSocio(razonSocial)

      __zariContext.loader.open('Buscando documentos tipo 91')
      AsientoContableService.obtenerDocumentosTipo91xIdSocio(_idSocio)
        .then(({ data }) => {
          if (data && data.length > 0) {
            setListaAsientosContables(data)
          } else {
            __zariContext.snack('warning', 'No se encontraron documentos bajo tipo 91 del proveedor seleccionado.')
          }
        })
        .catch(() => {
          __zariContext.snack('warning', 'No se encontraron documentos bajo tipo 91 del proveedor seleccionado.')
        })
        .finally(() => {
          __zariContext.loader.close()
        })
    },
    [__zariContext]
  )

  const limpiarDatos = React.useCallback(() => {
    limpiarIdDocumento()
    setRazonSocialSocio(null)
    setIdAsientoContable(null)
    setListaAsientosContables([])
  }, [limpiarIdDocumento])

  const clickConsultar = React.useCallback(() => {
    asignarIdDocumento(idAsientoContable)
  }, [idAsientoContable, asignarIdDocumento])

  return (
    <Portlet>
      <Portlet.Header title='Asientos Contables' breadcrumbs={portletBreadcrumbs} />
      <Portlet.Body>
        <Form>
          <Row>
            <Col md={3}>
              <FormGroups.ProveedorFormGroup asignarDatos={asignarDatos} limpiarDatos={limpiarDatos} razonSocialSocio={razonSocialSocio} />
            </Col>
            <Col md={3}>
              <FormGroups.AsientoContableFormGroup
                idAsientoContable={idAsientoContable}
                setIdAsientoContable={setIdAsientoContable}
                listaAsientosContables={listaAsientosContables}
                limpiarIdDocumento={limpiarIdDocumento}
              />
            </Col>
            <Col md={1}>
              <Button onClick={clickConsultar}>Consultar</Button>
            </Col>
          </Row>
        </Form>
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(FiltrosSection)
